const currencies: any = require('./currencies.json');

export const getRequestedCurrency = (currencyCode?: string) => {
    if (currencyCode && currencies[currencyCode]) {
        return currencies[currencyCode];
    }
    return currencies;
};
